import styled from 'styled-components'

import { theme } from '@/theme'

export const ImagePaddingWrapper = styled.div`
  padding-left: ${theme.spacing.tiny};
`
